import { render, staticRenderFns } from "./ClearInputButton.vue?vue&type=template&id=5b37fd17&scoped=true&"
import script from "./ClearInputButton.vue?vue&type=script&lang=js&"
export * from "./ClearInputButton.vue?vue&type=script&lang=js&"
import style0 from "./ClearInputButton.vue?vue&type=style&index=0&id=5b37fd17&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b37fd17",
  null
  
)

export default component.exports